var modAffiliateForm = function(){
    var scope = ".js-mod-affiliate-form";

    ui.ready(
        scope,
        function($mod){
            var $form = $mod.find(scope+"__form");
            $form.submit(function(ev){
                ev.preventDefault();
                console.log($form.getValues());
                var isOk = $form.checkRestrictions();
                if(isOk){
                    gvf.endpoint(
                        "web\\affiliateController::registerRequest",
                        {affiliateData:$form.getValues()},
                        function(response){
                            console.log(response);
                            if(response.status=="ok"){
                                window.location = response.url;
                            }else{
                                utils.alertEndpointResponse(response);
                            }
                        }
                    );
                }
            });
        }
    );
}();
